<template>
  <v-container fluid class="pa-0 step-container">
    <VirtualizeTable
      show-pagination
      show-all-option
      :items="rows"
      :headers="tableColumns"
      :loading="loading"
      :pagination="pagination"
      @onChangeItemsPerPage="handleItemsPerPageChange"
      @onChangePage="handlePageChange"
    >
      <!-- Notes -->
      <template #migrationPoll.notes="{ item }">
        <v-edit-dialog v-if="currentStep.status !== StepsStatusesMap.SIGNED">
          <span class="caption" v-if="!$v(item, 'migrationPoll.notes')">
            Click to type notes...
          </span>
          <span class="caption" v-else>
            {{ $v(item, 'migrationPoll.notes') }}
          </span>
          <template v-slot:input>
            <v-text-field
              counter
              single-line
              label="Edit note"
              :value="$v(item, 'migrationPoll.notes')"
              @change="
                (value) => handleChange(item.id, { notes: value.trim() })
              "
            />
          </template>
        </v-edit-dialog>
        <span class="caption" v-else>
          {{ $v(item, 'migrationPoll.notes') }}
        </span>
      </template>
    </VirtualizeTable>
    <v-snackbar color="success" timeout="1500" v-model="snackbar">
      The row has been updated
    </v-snackbar>
  </v-container>
</template>

<script>
import _ from 'lodash';
import VirtualizeTable from '@/components/common/VirtualizeTable';
import { StepsStatusesMap } from '@/constants';
import { processingResultsApiV1 } from '@/api/v1';
import { processingResultsApiV2 } from '@/api/v2';

export default {
  props: {
    currentStep: {
      type: Object,
      default: () => ({})
    },
    tableColumns: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    StepsStatusesMap,
    rows: [],
    loading: false,
    pagination: {
      page: 1,
      pageCount: 2,
      pageSize: 200,
      rowCount: 0
    },
    snackbar: false
  }),
  components: {
    VirtualizeTable
  },
  async mounted() {
    await this.getRows();
  },
  methods: {
    async getRows() {
      this.loading = true;
      const resultId = this.$route.params.result_id;
      const isFetchAll = this.pagination.pageSize === 'All';
      const stepParams = _.get(this.currentStep, 'params', {});
      const params = isFetchAll
        ? stepParams
        : {
            page: this.pagination.page,
            rowsPerPage: this.pagination.pageSize,
            ...stepParams
          };

      const { items, pagination } = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).fetchRows(resultId, params, isFetchAll);

      this.rows = items;

      if (pagination) {
        this.pagination = pagination;
      }

      this.loading = false;
    },
    async handleChange(resultRowId, updated) {
      this.loading = true;

      const updatedRow = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).updateRow(this.$route.params.result_id, resultRowId, {
        migrationPoll: updated
      });

      _.merge(_.find(this.rows, { id: resultRowId }), updatedRow);

      if (this.currentStep.status !== StepsStatusesMap.IN_PROGRESS) {
        this.$emit('onUpdateStepStatus', StepsStatusesMap.IN_PROGRESS);
      }

      this.loading = false;
      this.snackbar = true;
    },
    handleItemsPerPageChange(itemsPerPage) {
      this.pagination.page = 1;
      this.pagination.pageSize = itemsPerPage;
      this.getRows();
    },
    handlePageChange(pageNum) {
      if (this.pagination.page !== pageNum) {
        this.pagination.page = pageNum;
        this.getRows();
      }
    }
  }
};
</script>
